import {getJson} from '@/util/ajaxUtils';

export function getRoomsByExtId(extId) {
    return getJson(`/room/${extId}`, {});
}

export function getRooms(params) {
    return getJson('/room/list', {params});
}

export function getAllRooms(extId) {
    return getJson(`/room/all/list/${extId}`, {});
}

export function listMember(params) {
    return getJson('/room/member/list', {params});
}

export function syncRoom(extId) {
    return getJson(`/room/sync/${extId}`, {});
}

export function transferRoom(params) {
    return getJson('/room/transfer', {params});
}

export function members(chatId) {
    return getJson(`/room/members/${chatId}`, {});
}

export function getMemberDetail(chatId, extId) {
    return getJson(`/room/member/${chatId}/${extId}`, {});
}
